<template>
  <div class="replay-search-wrap">
    <el-form ref="form" :model="model" :inline="true" :rules="rules">
      <el-form-item :label="'任务:' | translateTo" prop="taskId">
        <el-select v-model="model.taskId" @change="taskChange" clearable>
          <el-option :label="'请选择:' | translateTo" value="" />
          <el-option
            v-for="item in taskList"
            :key="item.id"
            :label="item.name | translateTo"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="'设备:' | translateTo" prop="sn">
        <el-select v-model="model.sn" clearable multiple collapse-tags filterable>
          <el-option :label="'请选择:' | translateTo" value="" />
          <el-option
            v-for="item in deviceList"
            :key="item.sn"
            :label="item.name"
            :value="item.sn"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="'时间:' | translateTo" prop="rangeDateVal">
        <el-date-picker
          v-model="model.rangeDateVal"
          type="datetimerange"
          :range-separator="'至' | translateTo"
          :start-placeholder="'开始日期' | translateTo"
          :end-placeholder="'结束日期' | translateTo"
          value-format="timestamp"
          clearable
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="'回放速度:' | translateTo" prop="playSpeed">
        <el-select v-model="model.playSpeed">
          <el-option label="1x" :value="1" />
          <el-option label="2x" :value="2" />
          <el-option label="6x" :value="6" />
          <el-option label="10x" :value="10" />
          <el-option label="20x" :value="20" />
          <el-option label="40x" :value="40" />
          <el-option label="60x" :value="60" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validateEvent" :loading="replayLoading">
          {{ '回放' | translateTo }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getTask } from '@/api/auth';
import { getDevicesList } from '@/api/baseInfo';
import { getTime, toTimestamp } from '@/utils/date';

export default {
  props: {
    rules: {
      type: Object,
      default: () => ({})
    },
    replayLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const { beginTime, endTime, taskId, sn } = this.$route.query;
    const now = Date.now();
    const begin = toTimestamp(beginTime || now - getTime('h'), 'm');
    const end = toTimestamp(endTime || now, 'm');
    return {
      model: {
        taskId: taskId || '',
        sn: sn ? [sn] : [],
        rangeDateVal: [begin, end],
        playSpeed: 10
      },
      taskList: [],
      deviceList: []
    };
  },
  methods: {
    dateChange(val) {
      if (!val[0] || !val[1]) return;
      const begin = toTimestamp(val[0], 'm');
      const end = toTimestamp(val[1], 'm');
      if (end - begin > 36e5) {
        this.model.rangeDateVal.splice(0, Infinity, begin, begin + 36e5);
      } else {
        this.model.rangeDateVal.splice(0, Infinity, begin, end);
      }
    },
    getTask() {
      getTask().then(res => {
        this.taskList.splice(0, Infinity, ...res.data);
      });
    },
    taskChange() {
      this.getDeviceList();
    },
    getDeviceList() {
      getDevicesList({ taskId: [this.model.taskId] }).then(res => {
        this.deviceList.splice(0, Infinity, ...res.data);
      });
    },
    resetDevice() {
      this.model.sns.splice(0, Infinity);
    },
    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('replay', this.model);
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.getTask();
    this.model.taskId && this.getDeviceList();
  },
  mounted() {
    this.$nextTick(() => {
      this.model.taskId && this.validateEvent();
    });
  }
};
</script>

<style></style>
